/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { IdentityError } from './IdentityError';
import {
    IdentityErrorFromJSON,
    IdentityErrorFromJSONTyped,
    IdentityErrorToJSON,
} from './IdentityError';

/**
 * 
 * @export
 * @interface IdentityExceptionDetails
 */
export interface IdentityExceptionDetails {
    /**
     * 
     * @type {Array<IdentityError>}
     * @memberof IdentityExceptionDetails
     */
    errors?: Array<IdentityError> | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityExceptionDetails
     */
    $type?: IdentityExceptionDetailsTypeEnum;
}


/**
 * @export
 */
export const IdentityExceptionDetailsTypeEnum = {
    PtwPtw100AppZeroApplicationAuthorizationApplicationServicesIdentityExceptionDetailsPtwPtw100AppZeroApplication: 'Ptw.Ptw100.AppZero.Application.Authorization.ApplicationServices.IdentityExceptionDetails, Ptw.Ptw100.AppZero.Application'
} as const;
export type IdentityExceptionDetailsTypeEnum = typeof IdentityExceptionDetailsTypeEnum[keyof typeof IdentityExceptionDetailsTypeEnum];


/**
 * Check if a given object implements the IdentityExceptionDetails interface.
 */
export function instanceOfIdentityExceptionDetails(value?: unknown): value is IdentityExceptionDetails {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(IdentityExceptionDetailsTypeEnum)[0];
}

export function IdentityExceptionDetailsFromJSON(json: any): IdentityExceptionDetails {
    return IdentityExceptionDetailsFromJSONTyped(json, false);
}

export function IdentityExceptionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityExceptionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(IdentityErrorFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function IdentityExceptionDetailsToJSON(value?: IdentityExceptionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(IdentityErrorToJSON)),
        '$type': value.$type,
    });
}

